import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  triggerLabel: {
    id: 'Lync1F',
    defaultMessage: 'When',
    description: 'Label for the trigger selection dropdown',
  },
  triggerPlaceholder: {
    description: 'Placeholder for the trigger selection dropdown',
    defaultMessage: 'Select trigger...',
    id: 'sCqq3R',
  },
  triggerFilterLabel: {
    description: 'Label for the trigger filter row showing the tag field name',
    defaultMessage: 'Where tag *',
    id: 'Dbysyr',
  },
});
